import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TotalFundData } from "../../contexts/FundContext/FundInterface";
import { Dayjs } from "dayjs";

interface MakePaymentInfo {
  funds: TotalFundData[];
  loadId: string;
  fundId: number;
  fundName: string;
  fundAmt: string;
  loanBalance: number;
  amountDue: number;
  dueDate: string;
  accruedInterest: string;
  loanPayoff: number;
  autoDebitExists: string;
  value: string;
  effectiveDates: string | null;
  loanData: null;
  minimumInterest: string;
  transactionId: string;
  loanMinInt: string;
  loanName: string;
  loanType: string;
  methodofPayment: string;
  checkReference: string;
  comments: string;
}

const initialState: MakePaymentInfo = {
  funds: [],
  loadId: "",
  fundId: 0,
  fundName: "",
  fundAmt: "",
  loanBalance: 0.0,
  amountDue: 0.0,
  dueDate: "",
  accruedInterest: "",
  loanPayoff: 0,
  autoDebitExists: "",
  value: "amountDue",
  effectiveDates: null,
  loanData: null,
  minimumInterest: "",
  transactionId: "",
  loanMinInt: "",
  loanName: "",
  loanType: "",
  checkReference: "",
  methodofPayment: "",
  comments: ""
};

const makePaymentsSlice = createSlice({
  name: "makePayment",
  initialState,
  reducers: {
    setCreateMakePayment: (
      state,
      action: PayloadAction<Partial<MakePaymentInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeMakePayment: () => initialState,
  },
});

export const { setCreateMakePayment, removeMakePayment } =
  makePaymentsSlice.actions;
export default makePaymentsSlice.reducer;
